import { render } from "./FileDownload.vue?vue&type=template&id=b8ad4d04&ts=true"
import script from "./FileDownload.vue?vue&type=script&lang=ts"
export * from "./FileDownload.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__